/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewLoginAndRegisterSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_LOGIN_AND_REGISTER')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class NewLoginAndRegisterSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewLoginAndRegisterSettingParser.decode(input).map(res => new NewLoginAndRegisterSetting(res));
    }
    static unsafeDecode(input) {
        return NewLoginAndRegisterSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewLoginAndRegisterSettingParser.encode(data);
    }
    static schema() {
        return NewLoginAndRegisterSettingParser.schema();
    }
}
